import { call, put, select } from "redux-saga/effects"

import api from "apis"

import { addWizardData } from "../actions"

export default function* fetchWarrantyOffers(action) {
  const state = yield select()
  const styleCode = state?.choices?.style_code?.value
  const price = action.price

  if (!styleCode || !price) return

  const result = yield call(
    api.get,
    `/api/v10/products/${styleCode}/warranty_offers?price=${price}`
  )

  if (result?.data) {
    let warrantyData = {
      disabled: true,
      options: result.data,
      pref: "warranty",
      price,
    }

    yield put(addWizardData(warrantyData))
  }
}
